import { journalTexts } from 'consts/text';
import { parseStringIntoFormattedStringDate } from 'utils/parsers/dateTime/parseStringIntoFormattedStringDate';
import { automaticCheckJournalFields } from 'consts/automaticCheckJournal/automaticCheckJournalFields';
import { ContractValidDisplay } from 'components/molecules';
import {
    AutomaticCheckJournalBasicDTO,
    AutomaticCheckProgressStatus,
    AutomaticCheckResultStatus,
} from 'types/automaticCheckJournal';
import { AppParagraph } from 'components/atoms';
import { AppTableProps } from 'components/organisms';
import dayjs from 'dayjs';

const renderStatus = (status: AutomaticCheckProgressStatus) => {
    switch (status) {
        case 'PENDING':
            return journalTexts.journalDetails.common.automaticCheckJournal.status.PENDING;
        case 'IN_PROGRESS':
            return journalTexts.journalDetails.common.automaticCheckJournal.status.IN_PROGRESS;
        case 'COMPLETED_WITH_ERRORS':
            return journalTexts.journalDetails.common.automaticCheckJournal.status
                .COMPLETED_WITH_ERRORS;
        case 'COMPLETED_OK':
            return journalTexts.journalDetails.common.automaticCheckJournal.status.COMPLETED_OK;
        case 'FAILED':
            return journalTexts.journalDetails.common.automaticCheckJournal.status.FAILED;
        default:
            return journalTexts.journalDetails.common.automaticCheckJournal.status.UNKNOWN;
    }
};
const renderResult = (result: AutomaticCheckResultStatus) => {
    switch (result) {
        case 'OK':
            return journalTexts.journalDetails.common.automaticCheckJournal.result.OK;
        case 'MISSING':
            return journalTexts.journalDetails.common.automaticCheckJournal.result.MISSING;
        default:
            return journalTexts.journalDetails.common.automaticCheckJournal.status.UNKNOWN;
    }
};
export const columns: AppTableProps<AutomaticCheckJournalBasicDTO>['columns'] = [
    {
        title: journalTexts.journalDetails.common.automaticCheckJournal.columns.period,
        dataIndex: automaticCheckJournalFields.startDate,
        key: automaticCheckJournalFields.startDate,
        render: (_, record) => (
            <AppParagraph>
                {`${parseStringIntoFormattedStringDate(record.from)} - 
                ${parseStringIntoFormattedStringDate(record.to)}`}
            </AppParagraph>
        ),
        isVisibleAsExtendableInMobile: true,
    },
    {
        title: journalTexts.journalDetails.common.automaticCheckJournal.columns.date,
        dataIndex: automaticCheckJournalFields.date,
        key: automaticCheckJournalFields.date,
        render: (dateTime: AutomaticCheckJournalBasicDTO['executedAt']) =>
            dayjs(dateTime).format('DD.MM.YYYY'),
        isVisibleAsExtendableInMobile: true,
    },
    {
        title: journalTexts.journalDetails.common.automaticCheckJournal.columns.checkedBy,
        dataIndex: automaticCheckJournalFields.executedByName,
        key: automaticCheckJournalFields.executedByName,
        isVisibleAsExtendableInMobile: true,
    },
    {
        title: journalTexts.journalDetails.common.automaticCheckJournal.columns.progressStatus,
        dataIndex: automaticCheckJournalFields.progressStatus,
        key: automaticCheckJournalFields.progressStatus,
        render: (progressStatus: AutomaticCheckJournalBasicDTO['progressStatus']) =>
            renderStatus(progressStatus),
        isVisibleAsExtendableInMobile: true,
    },
    {
        title: journalTexts.journalDetails.common.automaticCheckJournal.columns.result,
        dataIndex: automaticCheckJournalFields.resultStatus,
        key: automaticCheckJournalFields.resultStatus,
        render: (resultStatus: AutomaticCheckJournalBasicDTO['resultStatus']) =>
            renderResult(resultStatus),
        isVisibleAsExtendableInMobile: true,
    },
    {
        title: journalTexts.journalDetails.common.automaticCheckJournal.columns.sendNotification,
        dataIndex: automaticCheckJournalFields.sendNotification,
        key: automaticCheckJournalFields.sendNotification,
        render: (hasSendNotification: AutomaticCheckJournalBasicDTO['notificationsSent']) => (
            <ContractValidDisplay
                contractValid={hasSendNotification}
                dataTestId="hasSendNotification"
            />
        ),
        isVisibleAsExtendableInMobile: true,
    },
];
